// eslint-disable-next-line spaced-comment
///<reference types="@wcp/wcp-consent" />
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Constants } from '@shared/utils/constants';
import { getWindow, getDocument } from '@shared/services/window';
import { stringifyError } from '@shared/utils/errorUtils';
import { logger } from '@src/logger';
import { MsClarity, MsClarityEnabledEnvironments } from '@shared/components/msClarity';
import { COMSCORE_URL } from '@appsource/utils/comscore';
import * as appConfig from '@shared/services/init/appConfig';
const shouldTrack = (consent)=>{
    return consent.Required && consent.Analytics || !consent.Required;
};
let siteConsent = null;
const CookieBannerComponent = ()=>/*#__PURE__*/ _jsx("div", {
        id: Constants.Cookies.WCPBannerName,
        className: Constants.Cookies.WCPBannerName
    });
// wrapper to WCP
export const CookieBanner = ({ resetCookieManagementModal, locale, updateSiteConsent, updateIsConsentRequired, isManagementModalOpen, siteEnvironment })=>{
    const [allowTracking, setAllowTracking] = useState(false);
    const [isComScorePresent, setIsComScorePresent] = useState(false);
    const isMsClarityEnabled = MsClarityEnabledEnvironments.some((environment)=>siteEnvironment === environment);
    const handleNewConsent = (newConsent)=>{
        const telemetryData = {
            page: getWindow().location.href,
            action: Constants.Telemetry.Action.ConsentBanner,
            actionModifier: Constants.Telemetry.ActionModifier.HandleNewConsent,
            details: 'onConsentChanged: ' + JSON.stringify(newConsent)
        };
        logger.info(telemetryData.details, {
            action: telemetryData.action,
            actionModifier: telemetryData.actionModifier
        });
        setAllowTracking(shouldTrack(newConsent));
    };
    const manageCookies = ()=>{
        if (siteConsent) {
            siteConsent.manageConsent();
            resetCookieManagementModal();
        }
    };
    const getConsent = ()=>{
        var _getWindow_WcpConsent, _getWindow;
        (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow_WcpConsent = _getWindow.WcpConsent) === null || _getWindow_WcpConsent === void 0 ? void 0 : _getWindow_WcpConsent.init(locale, Constants.Cookies.WCPBannerName, (err, _siteConsent)=>{
            const telemetryData = {
                page: getWindow().location.href,
                action: Constants.Telemetry.Action.ConsentBanner,
                actionModifier: Constants.Telemetry.ActionModifier.GetConsent,
                details: 'initConsentBanner: start'
            };
            if (err) {
                telemetryData.actionModifier = Constants.Telemetry.ActionModifier.Error;
                telemetryData.details = 'initConsentBanner Error: ' + stringifyError(err);
            } else {
                siteConsent = _siteConsent;
                const wcpConsent = _siteConsent.getConsent();
                appConfig.set('siteConsent', wcpConsent);
                updateSiteConsent(wcpConsent);
                updateIsConsentRequired(_siteConsent.isConsentRequired);
                telemetryData.details = 'initConsentBanner: ' + JSON.stringify(_siteConsent.getConsent());
                setAllowTracking(shouldTrack(siteConsent.getConsent()));
                if (!getDocument().getElementById(Constants.Cookies.WCPManageCookieBtnId) && _siteConsent.isConsentRequired) {
                    telemetryData.actionModifier = Constants.Telemetry.ActionModifier.Error;
                    telemetryData.details = 'error - no manage btn for local: ' + locale;
                    logger.error(telemetryData.details, {
                        action: telemetryData.action,
                        actionModifier: telemetryData.actionModifier
                    });
                }
            }
            logger.info(telemetryData.details, {
                action: telemetryData.action,
                actionModifier: telemetryData.actionModifier
            });
        }, (newConsent)=>{
            updateSiteConsent(newConsent);
            appConfig.set('siteConsent', newConsent);
            handleNewConsent(newConsent);
        });
    };
    const wcpConsentCallBack = ()=>{
        var _getWindow;
        logger.info(`wcpConsentCallBack: get WcpConsent :${!!((_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.WcpConsent)}`, {
            action: Constants.Telemetry.Action.ConsentBanner,
            actionModifier: Constants.Telemetry.ActionModifier.WcpConsentCallBack
        });
        getConsent();
    };
    const wcpConsentListener = ()=>{
        var _getWindow;
        ((_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.WcpConsent) ? getConsent() : getWindow().addEventListener(Constants.Cookies.WCPEventName, wcpConsentCallBack);
        return ()=>{
            try {
                getWindow().removeEventListener(Constants.Cookies.WCPEventName, wcpConsentCallBack);
                logger.info('removeEventListener', {
                    action: Constants.Telemetry.Action.ConsentBanner,
                    actionModifier: Constants.Telemetry.ActionModifier.RemoveEventListener
                });
            } catch (error) {
                logger.error(`Error removing event listener: ${error}`, {
                    action: Constants.Telemetry.Action.ConsentBanner,
                    actionModifier: Constants.Telemetry.ActionModifier.Error
                });
            }
        };
    };
    const loadComScoreScript = ()=>{
        setIsComScorePresent(true);
        const scriptElement = getDocument().createElement('script');
        scriptElement.src = COMSCORE_URL;
        scriptElement.async = false;
        document.body.appendChild(scriptElement);
    };
    useEffect(()=>{
        if (isManagementModalOpen) {
            manageCookies();
        }
    }, [
        isManagementModalOpen
    ]);
    useEffect(()=>{
        wcpConsentListener();
    }, []);
    useEffect(()=>{
        if (allowTracking && !isComScorePresent) {
            loadComScoreScript();
        }
    }, [
        allowTracking
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            isMsClarityEnabled && /*#__PURE__*/ _jsx(MsClarity, {
                allowTracking: allowTracking
            }),
            /*#__PURE__*/ _jsx(CookieBannerComponent, {})
        ]
    });
};
